import React, {useState} from 'react';
import {ErrorMessage, useField} from 'formik';

export const OptionList = ({ label,data,setData,selectedItem, ...props }) => {
    const [field, meta] = useField(props);
    let optionList=data.map(data=> {
        if (data.status === 1)
            return (<option
                    key={data.id}
                    value={data.id}
                    // selected={`${data.id === selectedItem ? "selected":""}`}
                    >{data.name}
                    </option>)
    })
    if(selectedItem === undefined)
    optionList.unshift(<option key={-1} style={{color:"red"}} selected={"selected"}>Seçim edin</option>)

    const setSelect= (e) =>{
        console.log(e.target.value)
            setData(e.target.value)
    }
  return (
    <div className="mb-2">
      <label htmlFor={field.name}>{label}</label>
      <select
          value={selectedItem}
          className={`form-control shadow-none`}
          onChangeCapture={setSelect}
          // onChangeCapture={}
          {...field}
          {...props}
      >
          {optionList}
      </select>
      <ErrorMessage component="div" name={field.name} className="error" />
    </div>
  )
}
